(async () => {
    const { Core } = await importModule('Core');

    customElements.define('collection-sort', class extends Core {
        render() {
            this._handleChange();
        }

        _handleChange() {
            this.addEventListener('change', this._onChange.bind(this));
        }

        _onChange() {
            this.publish('filter:change');
        }
    })
})();

document.querySelector('.\\#collection-mobile-filters-button').addEventListener('click', function (e) {
  const filtersRoot = document.querySelector('#cloud_search_filters_root .cloud-search-page-controls__filters-link');

  if (filtersRoot) {
    filtersRoot.click();

    e.preventDefault();
    e.stopImmediatePropagation();
  }
});